angular.module('app').config(function ($stateProvider) {
  $stateProvider.state('my.planner', {
    url: 'planner/',
    abstract: true,
    template: '<ui-view></ui-view>'
  });
});
